import { clsx } from "clsx";
import { useLocation } from "react-router-dom";

import RenderIf from "common/components/RenderIf";
import CouponBanner from "common/components/WorkspaceLayoutContainer/WorkspaceLayout/CouponBanner";
import useNavStore from "common/hooks/useNavStore";
import type { NavItemType } from "common/types";

import DesktopNav from "./DesktopNav";

import type { JSX, ReactNode } from "react";

interface DesktopLayoutProps {
  navItems: NavItemType[];
  children: ReactNode;
  bannersComponent: JSX.Element;
}

export default function DesktopLayout({
  navItems,
  children,
  bannersComponent,
}: DesktopLayoutProps) {
  const { isNavExpanded, setIsNavExpanded } = useNavStore();
  const { pathname } = useLocation();

  const isSettingsPage = pathname.includes("/settings");

  return (
    <div className="overflow-hidden flex-col flex h-dvh">
      <CouponBanner />
      <div className="flex overflow-hidden grow bg-[linear-gradient(132deg,#fff_-4.58%,#f5f6f9_42.09%,#dce1ea_85.29%)]">
        <RenderIf condition={!isSettingsPage}>
          <DesktopNav
            isExpanded={isNavExpanded}
            setIsExpanded={setIsNavExpanded}
            navItems={navItems}
          />
        </RenderIf>
        <div className="flex flex-col px-2 flex-1 min-w-0">
          <RenderIf condition={!isSettingsPage}>
            <button
              aria-label="expand"
              className={clsx(
                "w-2 h-full absolute z-10",
                isNavExpanded ? "cursor-w-resize" : "cursor-e-resize",
              )}
              type="button"
              onClick={() => setIsNavExpanded(!isNavExpanded)}
            />
          </RenderIf>

          <main className="flex flex-col py-2 relative pt-2 gap-y-1.5 min-h-0 grow">
            {bannersComponent}
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}
